/**
 * Значения по умолчанию для новых элементов планировки.
 */

import { WallMaterial, defaultDoorPreset, defaultWindowPreset } from "@/shared/catalog";
import type { OpeningKind } from "./types";

export const WALL_DEFAULTS = {
	/** Межкомнатная перегородка, мм */
	thickness: 120,
	/** Высота потолка, мм */
	height: 2700,
} as const;

/** Внешняя несущая стена, мм */
export const EXTERIOR_WALL_THICKNESS = 250;

export const BEARING_WALL_DEFAULTS = {
	thickness: EXTERIOR_WALL_THICKNESS,
	material: WallMaterial.Brick,
} as const;

/** Размеры новых проёмов — первые элементы разделов «Двери» и «Окна» каталога. */
export const OPENING_PRESET: Record<
	OpeningKind,
	{ item: string; width: number; height: number; sill: number }
> = {
	door: defaultDoorPreset(),
	window: defaultWindowPreset(),
};

/** Минимальные допустимые размеры проёма, мм */
export const OPENING_LIMITS = {
	minWidth: 300,
	minHeight: 300,
} as const;
